<template>
  <div class="sy_out_pupop" v-loading = "loading">
    <div class="sy_out_form" style="position: relative">
      <div
        v-preventReClick
        style="
          position: absolute;
          right: 30px;
          top: 30px;
          font-size: 30px;
          color: #606266;
          cursor: pointer;
        "
        @click="back"
      >
        <i class="el-icon-circle-close" />
      </div>
      <div class="rkxx">
        <img
          src="@/assets/img/syck.png"
          style="height: 25px; margin-bottom: 37px"
        >
        <el-form
          ref="syckForm"
          :model="syckForm"
          :rules="rules_syck"
          label-width="120px"
          :disabled="isDisabled"
          label-position="right"
        >
          <el-form-item label="化学品:" class="is-required" prop="hxpBm">
            <el-cascader
              v-if="!(isDisabled || bgdisable)"
              v-model="syckForm.hxpBm"
              style="width: 100%"
              :options="options"
              clearable
              :disabled="bgdisable"
              placeholder="请选择化学品"
              :props="{ emitPath: false }"
              filterable
              @change="hxpOptionsChange"
            />
            <el-input
              v-else
              v-model="syckForm.hxpMc"
              disabled
              placeholder=""
            />
          </el-form-item>

          <el-form-item label="仓库:" class="is-required" prop="ckId">
            <el-select
              v-if="!isDisabled"
              v-model="syckForm.ckId"
              style="width: 100%"
              placeholder="请选择"
              @change="ckChange"
            >
              <el-option
                v-for="(item, index) in ckOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-input
              v-else
              v-model="syckForm.ckmc"
              disabled
              placeholder=""
            />
          </el-form-item>
          <el-form-item v-if="!isDisabled" label="当前库存数量:" prop="kcl">
            <el-input
              v-model="syckForm.kcl"
              disabled
              style="width: 65%"
              placeholder=""
            />
            <el-input
              v-model="syckForm.kclDwLabel"
              disabled
              style="width: calc(35% - 10px); margin-left: 10px"
              placeholder="单位"
            />
          </el-form-item>
          <el-form-item label="出库数量:" class="is-required">
            <el-col :span="15">
              <el-form-item prop="cksl" style="width: 100%">
                <el-input
                  v-model="syckForm.cksl"
                  type="number"
                  style="width: 100%"
                  placeholder=""
                /> </el-form-item></el-col>
            <el-col :span="1"> &nbsp;</el-col>
            <el-col :span="8">
              <!-- style="width: 100%; margin-left: 10px" -->
              <el-form-item prop="ckslDw" style="width: 100%">
                <el-select
                  v-model="syckForm.ckslDw"
                  placeholder="单位"
                  @change="ckslChange"
                >
                  <el-option
                    v-for="(item, index) in dwlxList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  /> </el-select></el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="领用人:" class="is-required" prop="lyrId">
            <el-select
              v-if="!(isDisabled || bgdisable)"
              v-model="syckForm.lyrId"
              filterable
              style="width: 100%"
              placeholder="请选择"
              :disabled="bgdisable"
              @change="lyrChange"
            >
              <el-option
                v-for="(item, index) in lyrList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-input
              v-else
              v-model="syckForm.lyrxm"
              disabled
              placeholder=""
            />
          </el-form-item>
          <el-form-item label="领用日期:" class="is-required" prop="lyrq">
            <el-date-picker
              v-model="syckForm.lyrq"
              style="width: 100%"
              :picker-options="pickerBeginDateBefore"
              type="date"
              placeholder="选择日期"
            />
          </el-form-item>
          <el-form-item label="保管员:">
            <el-input
              v-model="syckForm.bgyxm"
              disabled
              placeholder="请输入"
            />
          </el-form-item>

          <el-form-item
            label="领用原因:"
            prop="lyyy"
            :rules="{
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'xt', 500);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="syckForm.lyyy"
              :disabled="bgdisable"
              placeholder="请输入"
            />
          </el-form-item>

          <el-form-item
            v-if="curStatus == 'add' || curStatus == 'copyAdd'"
            label="登记人:"
            class="is-required"
            prop="djr"
          >
            <el-input v-model="djr" disabled placeholder="" />
          </el-form-item>
          <el-form-item v-else label="登记人:" class="is-required">
            <el-input
              v-model="syckForm.djrLabel"
              disabled
              placeholder=""
            />
          </el-form-item>

          <el-form-item
            v-if="djsjshow"
            label="登记时间:"
            class="is-required"
            prop="djrq"
          >
            <el-date-picker
              v-model="syckForm.djsj"
              style="width: 100%"
              type="date"
              placeholder="选择日期"
              disabled
              format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
          <el-form-item v-else label="登记时间:">
            <el-date-picker
              :value="new Date()"
              type="date"
              style="width: 100%;"
              placeholder="选择日期"
              disabled
              format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
          <el-form-item
            label="备注:"
            style="width: 100%"
            prop="bz"
            :rules="{
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'xt', 225);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="syckForm.bz"
              :disabled="bgdisable"
              style="width: 100%"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item
            v-if="bgdisable"
            label="变更理由:"
            prop="bgly"
            style="width: 100%"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 1000);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="syckForm.bgly"
              type="textarea"
              :rows="3"
              resize="none"
              style="width: 100%"
              placeholder="请输入"
            />
          </el-form-item>
        </el-form>
        <div
          v-if="
            curStatus == 'copyAdd' || curStatus == 'add' || curStatus == 'bj'
          "
          class="buttonList"
        >
          <el-button
            type="primary"
            @click="ckSubmitTemp"
          >暂时保存</el-button>
          <el-button
            style=""
            type="primary"
            @click="ckSubmit('syckForm', 'rk', '出库成功!')"
          >出库</el-button>
        </div>

        <div
          v-if="curStatus == 'ck' && !curRowObj.bgcs >= 1"
          class="backButton"
        >
          <el-button type="primary" @click="ckSubmit('syckForm')">
            确定</el-button>
        </div>
        <div
          v-if="curStatus == 'bg' && !curRowObj.bgcs >= 1"
          class="backButton"
        >
          <el-button
            v-preventReClick
            type="primary"
            @click="ckSubmit('syckForm', 'bg', '变更')"
          >提交变更</el-button>
        </div>
      </div>
    </div>

    <div v-if="curRowObj.bgcs >= 1" class="bgcs_bg">
      <div class="rkxx">
        <div class="title" style="margin-bottom: 30px">
          <img src="@/assets/img/bgsp/ckbg.png" alt="" srcset="">
        </div>
        <bgcsOfDetail
          :cur-row-obj="curRowObj"
          :cur-type="curType"
          bgcs-t-k-name="disShow"
          @bacsCkXqShow="bacsCkXqShow"
        />

        <div v-if="curStatus == 'ck'" class="backButton">
          <el-button type="primary" @click="ckSubmit('syckForm')">
            确定</el-button>
        </div>
        <div v-if="curStatus == 'bg'" class="backButton">
          <el-button
            v-preventReClick
            type="primary"
            @click="ckSubmit('syckForm', 'bg', '变更')"
          >提交变更</el-button>
        </div>
      </div>
    </div>

    <!-- 详情弹框 -->
    <el-dialog :visible.sync="dialogFormVisible" width="1200px" center>
      <bgxqCom
        v-if="dialogFormVisible"
        bgcs-t-k-name="使用出库"
        :dgcs-xq-id="dgcsXqId"
      />
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          style="background-color: #4170ff; border: none"
          @click="dialogFormVisible = false"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { lengthValidate } from '@/assets/js/validate'
import bgxqCom from '@/components/bgxq/bgxqCom.vue'
import bgcsOfDetail from '@/components/bgxq/bgInDetail.vue'

import {
  syckhxp,
  lyrOptions,
  ckOptions,
  addSyck,
  userInfofLogin,
  getInformationById,
  beforeBGForm,
  bgSaveForm, addSyckTemp
} from '@/assets/js/common.js'
import { getdwforhxpBm } from '@/assets/js/yssq'
import { accMul } from '@/utils/number'
import {dealDataGy} from "@/utils/ppp";
export default {
  components: { bgcsOfDetail, bgxqCom },
  props: {
    curStatus: {
      type: String
    },
    curId: {
      type: String
    },
    djsjshow: {
      type: Boolean
    },
    bgdisable: {
      type: Boolean
    }
  },
  data() {
    const sljiaoyan = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入数量'))
      } else if (this.curStatus != 'bg' && value < 0) {
        callback(new Error('请输入正数'))
      } else if (
        /^-?[1-9]\d{0,8}(\.\d{1,3})?$|^-?0(\.\d{1,3})?$/.test(value) == false
      ) {
        return callback(new Error('整数位最大长度9位,保留3位小数'))
      } else callback()
      callback()
    }

    return {
      loading: false,
      pickerBeginDateBefore: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      pickerVal: [],
      isDisabled: false,
      dwlxList: [],
      ckOptions: [],
      lyrList: [],
      options: [],
      syckForm: {
        id: '',
        ckbh: '',
        ckId: '', // 仓库id
        ckmc: '',
        hxpBm: '',
        cksl: '',
        ckslDw: '',
        ckslDwLabel: '',
        zt: '',
        lyrq: '',
        lyrId: '',
        lyrxm: '',
        lyyy: '',
        bz: '',
        kcl: '',
        kclDw: '',
        kclDwLabel: '',
        bgyId: '',
        bgyxm: '',
        bgydh: '',
        bgly: '',
        djrLabel: '',
        djsj: ''
      },
      rules_syck: {
        hxpBm: [
          {
            required: true,
            message: '请选择化学品',
            trigger: ['blur', 'change']
          }
        ],
        ckId: [
          {
            required: true,
            message: '请选择仓库',
            trigger: ['blur', 'change']
          }
        ],
        kcl: [
          {
            required: true,
            message: '库存数量不能为空',
            trigger: ['blur', 'change']
          }
        ],
        cksl: [
          {
            required: true,
            validator: sljiaoyan,
            // message: "请输入",
            trigger: ['blur', 'change']
          }
        ],
        ckslDw: [
          {
            required: true,
            message: '请选择',
            trigger: ['blur', 'change']
          }
        ],
        // ckslbg: [
        //   { required: true, message: '请输入', trigger: ['blur', 'change'] }
        // ],
        lyrId: [
          {
            required: true,
            message: '领用人员不能为空',
            trigger: ['blur', 'change']
          }
        ],
        lyrq: [
          {
            required: true,
            message: '领用日期不能为空',
            trigger: ['blur', 'change']
          }
        ]
        // bgly: [
        //   { required: true, message: "请输入", trigger: ["blur", "change"] },
        // ],
      },
      djsj: new Date(),
      djr: '',

      curType: '',
      curRowObj: {}, // 当前行的对象
      dialogFormVisible: false,
      dgcsXqId: null
    }
  },
  computed: {},
  watch: {
    syckForm: {
      deep: true,
      handler(val) {
        if (val.hxpBm) {
          getdwforhxpBm(this.syckForm.hxpBm).then((e) => {
            this.dwlxList = e.data.data
          })
        }

        // if (val.cksl) this.syckForm.cksl = parseInt(this.syckForm.cksl);
      }
    }
  },
  mounted() {
    // 获取化学品
    syckhxp().then((res) => {
      if (res.status == 200) {
        this.options = res.data.data
      }
    })
    if(this.curStatus == 'add'){ //新增
      lyrOptions().then((res) => {
        if (res.status == 200) {
          this.lyrList = res.data.data
        }
      })
    }
    userInfofLogin().then((res) => {
      if (res.status == 200) {
        this.djr = res.data.data.name
      }
    })

    this.getInformationByType() // 根据类型获取表单项
  },
  created() {},

  beforeDestroy() {},
  methods: {
    lengthValidate,
    // 变更次数详情表格
    bacsCkXqShow(id) {
      this.dgcsXqId = id
      this.dialogFormVisible = !this.dialogFormVisible
    },
    initCon(curRow, curType) {
      this.curRowObj = curRow
      this.curType = curType
      this.dialogFormVisibl = false
    },
    sljy() {
      if(this.curStatus == 'bg'){ //变更不需要校验
        return true
      }
      var flag = true
      if (this.syckForm.ckslDw < this.syckForm.kclDw) {
        if (
          accMul(this.syckForm.cksl, (this.syckForm.kclDw - this.syckForm.ckslDw) * 1000) > this.syckForm.kcl
          // this.syckForm.cksl *
          //   (this.syckForm.kclDw - this.syckForm.ckslDw) *
          //   1000 >
          // this.syckForm.kcl
        ) {
          this.$message.error('超出库存数量')
          flag = false
        }
      } else if (this.syckForm.ckslDw > this.syckForm.kclDw) {
        if (
          accMul(this.syckForm.cksl, (this.syckForm.ckslDw - this.syckForm.kclDw) * 0.001) > this.syckForm.kcl
          // this.syckForm.cksl *
          //   (this.syckForm.ckslDw - this.syckForm.kclDw) *
          //   0.001 >
          // this.syckForm.kcl
        ) {
          this.$message.error('超出库存数量')
          flag = false
        }
      } else if (this.syckForm.ckslDw == this.syckForm.kclDw) {
        if (this.syckForm.cksl > this.syckForm.kcl) {
          this.$message.error('超出库存数量')
          flag = false
        }
      }
      return flag
    },
    // 获取仓库信息
    getCkOptionsByHXPbm(curBm,dataMes) {
      if(this.curStatus == 'bg' ){
        ckOptions(curBm,dataMes.ckId).then((res) => {
          if (res.status == 200) {
            this.ckOptions = res.data.data
            this.ckChange(dataMes.ckId)
          }
        })
      }else{
        if(curBm){
          ckOptions(curBm).then((res) => {
            if (res.status == 200) {
              this.ckOptions = res.data.data
              if(dataMes && dataMes.ckId){
                this.ckChange(dataMes.ckId)
              }
            }
          })
        }
        if(dataMes){
          lyrOptions().then((res) => {
            if (res.status == 200) {
              this.lyrList = res.data.data
              this.lyrList.findIndex((item) => {
                if(item.value == dataMes.lyrId){
                  this.syckForm.lyrId = dataMes.lyrId
                  this.syckForm.lyrxm = dataMes.lyrxm
                  return
                }
              })
            }
          })

        }
      }

    },
    getInformationByIdmes() {
      getInformationById(this.curId).then((res) => {
        if (res.status == 200) {
          if (this.curStatus != 'ck'){
            let mesxx = {...res.data.data}
            mesxx.ckId =  this.syckForm.ckId
            mesxx.ckmc =  this.syckForm.ckmc
            mesxx.bgyId =  this.syckForm.bgyId
            mesxx.bgydh =  this.syckForm.bgydh
            mesxx.bgyxm =  this.syckForm.bgyxm
            mesxx.kcl = this.syckForm.kcl
            mesxx.kclDw = this.syckForm.kclDw
            mesxx.kclDwLabel = this.syckForm.kclDwLabel
            if(this.curStatus != 'bg'){
              mesxx.lyrId =  this.syckForm.lyrId
              mesxx.lyrXm =  this.syckForm.lyrXm
            }
            this.syckForm = mesxx
            this.getCkOptionsByHXPbm(this.syckForm.hxpBm,res.data.data)
          }else{
            this.syckForm = res.data.data
          }
          if (this.curStatus == 'copyAdd') this.syckForm.id = ''
          this.djsj = new Date()
          this.$nextTick(() => {
            this.$refs.syckForm.clearValidate() //清楚页面所有校验结果
          })
        }
      })
    },
    getInformationByType() {
      if (this.curStatus == 'add') {
      } else if (this.curStatus == 'ck') {
        this.isDisabled = true
        this.getInformationByIdmes()
      } else if (this.curStatus == 'bj') {
        this.getInformationByIdmes()
      } else if (this.curStatus == 'copyAdd') {
        this.getInformationByIdmes()
      } else if (this.curStatus == 'bg') {
        // this.$refs['syckForm'].rules.cksl = this.$refs['syckForm'].rules.ckslbg
        this.getInformationByIdmes()
      }
    },
    // 变更时
    bgSub(curmsg) {
      // 变更校验
      beforeBGForm(this.syckForm).then((res) => {
        var data = '是否确认变更?'
        if (res.data.data.type == 'success') {
        }
        // 如果没有可注意事项
        else {
          data =
            "<span style='color:red'>" +
            res.data.data.msg +
            '</span>是否确认变更?'
        }
        this.$confirm(data, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'warning',
          center: true
        }).then((res) => {
          this.loading = true
          bgSaveForm(this.syckForm).then((res) => {
            this.loading = false
            if (res.status == 200) {
              this.$parent.pupopShow = false
              this.$parent.getHomeTableList()
              this.$message.success(curmsg)
            } else {
              return
            }
          }).catch((error) => {
            this.loading = false
          })
        })
      })
    },
    // 添加或是编辑(出库)
    addOrEdit(status, curmsg) {
      // beforeAddSyck(obj).then((res) => {
      //   if (res.status == 200 && res.data.data.type == "success") {
      this.$confirm('确认提交吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(async (res) => {
        this.loading = true
        this.syckForm.zt = status == 'zc' ? '00' : '01'
        this.syckForm.vdata = await dealDataGy()
        addSyck(this.syckForm).then((res) => {
          this.loading = false
          if (res.status == 200) {
            this.$parent.pupopShow = false
            this.$parent.getHomeTableList()
            this.$message.success(curmsg)
          }
        }).catch((error) => {
          this.loading = false
        })
      })
      // } else {
      //   this.$message.warning(res.data.data.msg);
      // }
      // });
    },
    // 暂时保存
    ckSubmitTemp() {
      this.syckForm.zt ='00'
      this.$confirm('确认暂时保存吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(async (res) => {
        this.loading = true
        this.syckForm.vdata = await dealDataGy()
        addSyckTemp(this.syckForm).then((res) => {
          this.loading = false
          if (res.status == 200) {
            this.$parent.pupopShow = false
            this.$parent.getHomeTableList()
            this.$message.success('暂存成功!')
          }
        }).catch((error) => {
          this.loading = false
        })
      })
    },
    // 出库保存
    ckSubmit(formSave, status, curmsg) {
      let statusOfSustop = false
      // this.syckForm.cksl = parseInt(this.syckForm.cksl);
      this.$refs[formSave].validate((valid, obj) => {
        statusOfSustop = valid
      })
      var res = this.sljy()

      // 查看的时候
      if (this.curStatus == 'ck') {
        this.$parent.pupopShow = false
        return
      } else if (
        this.curStatus == 'add' ||
        this.curStatus == 'bj' ||
        this.curStatus == 'copyAdd'
      ) {
        if (statusOfSustop && res) {
          this.addOrEdit(status, curmsg)
        }
        return
      } else if (this.curStatus == 'bg') {
        // 如果是变更的时候
        if (statusOfSustop) {
          this.bgSub(curmsg)
        }
        return
      }
    },
    ckslChange(val) {
      this.dwlxList.forEach((item) => {
        if (item.value == val) {
          this.syckForm.ckslDwLabel = item.label
        } else {
          return
        }
      })
    },
    lyrChange(curLyr) {
      this.lyrList.forEach((item) => {
        if (item.value == curLyr) {
          this.syckForm.lyrxm = item.label
        } else {
          return
        }
      })
    },

    ckChange(ckValue) {
      this.ckOptions.forEach((item) => {
        if (ckValue == item.value) {
          this.syckForm.ckId = item.value
          this.syckForm.ckmc = item.label
          this.syckForm.kcl = item.kcl
          this.syckForm.kclDw = item.kclDw
          this.syckForm.kclDwLabel = item.kclDwLabel
          this.syckForm.bgyxm = item.ckbgy
          this.syckForm.bgyId = item.ckbgyId
          this.syckForm.bgydh = item.ckbgyDh
        }
      })
    },
    hxpOptionsChange(curHxpbm) {
      // 切换化学品的时候其他关联字段清空
      this.syckForm.ckId = ''
      this.syckForm.ckmc = ''
      this.syckForm.kcl = ''
      this.syckForm.kclDw = ''
      this.syckForm.kclDwLabel = ''
      this.syckForm.bgyxm = ''
      this.syckForm.bgyId = ''
      this.syckForm.bgydh = ''
      this.syckForm.ckslDw = ''
      this.syckForm.ckslDwLabel = ''
      this.getCkOptionsByHXPbm(curHxpbm)
    },

    back() {
      this.$parent.pupopShow = false
    }
  }
}
</script>
<style scoped lang="less">
.sy_out_pupop {
  padding-top: 10px;
  .sy_out_form {
    width: 90%;
    max-width: 1200px;
    background-color: white;
    margin: auto;
    .syck,
    .rkxx {
      width: 80%;
      margin: auto;
      padding-top: 40px;
      padding-bottom: 10px;
    }
    .el-form {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .el-form-item {
        margin-right: 0;
        width: 45%;
      }
    }
  }
  .bgcs_bg {
    // padding: 0 20px 30px;
    // margin-top: 15px;
    // margin-bottom: 30px;
    // width: 90%;
    // margin-left: auto;
    // margin-right: auto;

    // background-color: white;

    // padding: 30px 10% 30px;

    width: 90%;
    max-width: 1200px;
    background-color: white;
    margin: 15px auto;
    margin-bottom: 15px;
    .rkxx {
      width: 80%;
      margin: auto;
      padding-top: 40px;
      padding-bottom: 10px;
    }
    .el-form {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .el-form-item {
        margin-right: 0;
        width: 45%;
      }
    }
  }
  .xuanze {
    margin-left: 10px;
    color: #ffffff;
    width: 65px;
    height: 39px;
    background: #4170ff;
    border-radius: 2px;
  }
  .buttonList {
    width: 498px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 40px;
    margin-bottom: 45px;
    display: flex;
    justify-content: center;
    .el-button:nth-child(1) {
      margin-right: 190px;
      background-color: #ebebeb;
      width: 148px;
      height: 60px;
      color: #333333;
      border: none;
    }
    .el-button:nth-child(2) {
      background-color: #4170ff;
      color: white;
      width: 148px;
      height: 60px;
      border: none;
    }
  }
  .backButton {
    width: 148px;
    margin: 30px auto 40px auto;
    .el-button {
      margin: auto;
      background-color: #4170ff;
      width: 148px;
      height: 60px;
      color: white;
      border: none;
    }
  }
}
/deep/input::-webkit-outer-spin-button,
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
/deep/input[type="number"] {
  -moz-appearance: textfield;
}
</style>
